import { makeStyles } from '@mui/styles';
import React from 'react';

interface LiquidityFacilityStandingCellRendererProps {
    value: boolean;
}

const muiStyles = makeStyles({
    goodStanding: {
        color: '#5AAC01',
        fontWeight: 'bold' as const
    },
    badStanding: {
        color: '#EA3323',
        fontWeight: 'bold' as const
    }
});

const LiquidityFacilityStandingCellRenderer = (props: LiquidityFacilityStandingCellRendererProps) => {
    const { value } = props;

    const classes = muiStyles(props);

    return (
        <span className={value ? classes.goodStanding : classes.badStanding}>
            {value ?
                'Good Standing'
                : 'Needs Attention'}
        </span>
    );
};

export default LiquidityFacilityStandingCellRenderer;